import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {IApprovalDetails, IApprovalsItem, IApprovalStatus, ListResponse,} from '@/models';

import {AxiosRequestConfig} from 'axios';
import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {message} from 'antd';
import {persist} from 'zustand/middleware';
import {t} from 'i18next';

export interface IApprovalStore {
  approvalList: IApprovalsItem[];
  approvalDetails: IApprovalDetails;
  nbHits: number;
  getApprovalList: (params) => void;
  changeApprovalStatus: (objectID: string, status: IApprovalStatus) => void;
  refetchApprovalDetails: (id: string) => void;
  getApprovalData: (
    id: string,
    onSuccess: (data: IApprovalDetails) => void
  ) => void;
  editApproval: (
    approvalId: string,
    data: IApprovalDetails,
    onSuccess: () => void
  ) => void;
}

export const useApprovalStore = create(
  persist<IApprovalStore>(
    set => ({
      approvalList: [],
      approvalDetails: undefined,
      nbHits: 0,
      editApproval: async (id, details) => {
        handleApiCallInStore(LoadingKeys.editApproval, async () => {
          await http.put<IApprovalDetails>(
            API_ENDPOINTS.approval.changeApprovalStatus(id),
            details
          );
        });
      },
      getApprovalList: async params => {
        handleApiCallInStore(LoadingKeys.GetApprovalsList, async () => {
          const {data} = await http.get<ListResponse<IApprovalsItem>>(
            API_ENDPOINTS.approval.all,
            {params} as AxiosRequestConfig
          );
          const {items, nbHits} = data;
          set(() => ({approvalList: items ?? [], nbHits}));
        });
      },
      getApprovalData: async (id, onSuccess) => {
        handleApiCallInStore(LoadingKeys.getApprovalData, async () => {
          const {data} = await http.get<IApprovalDetails>(
            API_ENDPOINTS.approval.getApprovalById(id)
          );
          onSuccess(data);
          set(() => ({approvalDetails: data}));
        });
      },
      refetchApprovalDetails: async id => {
        handleApiCallInStore(LoadingKeys.refetchApprovalData, async () => {
          const {data} = await http.get<IApprovalDetails>(
            API_ENDPOINTS.approval.getApprovalById(id)
          );
          set(() => ({approvalDetails: data}));
        });
      },
      changeApprovalStatus: async (objectID, status) => {
        handleApiCallInStore(LoadingKeys.ChangeApprovalStatus, async () => {
          const {data: approvalData} = await http.get<IApprovalDetails>(
            API_ENDPOINTS.approval.getApprovalById(objectID)
          );
          const {name, phone, email, countryCode, experiences} = approvalData;

          const mapExperience = experiences.map((item) => {
            const {hobbies, ...other} = item
            return {
              ...other,
              hobby: hobbies[0].objectID
            }
          })

          const changeStatusPayload = {
            name,
            phone,
            email,
            countryCode,
            experiences: mapExperience,
            status,
          };
          await http.put(
            API_ENDPOINTS.approval.changeApprovalStatus(objectID),
            changeStatusPayload
          );

          set(({approvalList}) => ({
            approvalList: approvalList.filter(
              item => item.objectID !== objectID
            ),
          }));
          message.success(
            status === 'approved'
              ? t('coachApprovedSuccessfully')
              : t('coachRejectedSuccessfully')
          );
        });
      },
    }),
    {
      name: 'approval-storage',

    }
  )
);
